import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RouteAppWrapper } from '~/components/route-app-wrapper';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

const UserSettings = lazy(() => import('~/apps/user-settings'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SETTINGS);

  useOnLoad(() => {
    const title = t('SETTINGS_PAGE_TITLE', { defaultValue: 'Settings' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SETTINGS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.CustomerFeatures }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.CustomerFeatures
      }
    });
  });

  return (
    <Tagged tag="screen-settings">
      <RouteAppWrapper maxWidth="sm" isXs={isXs}>
        <Suspense>
          <UserSettings />
        </Suspense>
      </RouteAppWrapper>
    </Tagged>
  );
}

Component.displayName = 'User Settings';
